var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171_978)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1199 2.94656C24.6959 0.998563 20.8629 0.668562 20.7009 0.654562C20.4449 0.632562 20.2019 0.777563 20.0969 1.01156C20.0929 1.01956 19.8789 1.64056 19.6719 2.23956C22.4889 2.73256 24.4029 3.82656 24.5049 3.88656C24.9829 4.16456 25.1429 4.77756 24.8639 5.25456C24.6789 5.57256 24.3439 5.75056 23.9999 5.75056C23.8289 5.75056 23.6569 5.70756 23.4989 5.61556C23.4709 5.59856 20.6629 4.00056 17.0019 4.00056C13.3399 4.00056 10.5309 5.59956 10.5029 5.61556C10.0259 5.89256 9.41388 5.72956 9.13688 5.25156C8.85988 4.77556 9.02088 4.16456 9.49688 3.88656C9.59888 3.82656 11.5199 2.72856 14.3449 2.23656C14.1269 1.63056 13.9069 1.01956 13.9029 1.01156C13.7979 0.776563 13.5549 0.628562 13.2989 0.654562C13.1369 0.667562 9.30388 0.997563 6.84788 2.97256C5.56388 4.15856 2.99988 11.0926 2.99988 17.0876C2.99988 17.1936 3.02688 17.2966 3.07988 17.3886C4.85088 20.4986 9.67888 21.3126 10.7789 21.3476C10.7859 21.3486 10.7919 21.3486 10.7979 21.3486C10.9919 21.3486 11.1749 21.2556 11.2899 21.0986L12.4799 19.4866C9.86988 18.8576 8.48988 17.8686 8.40688 17.8076C7.96288 17.4806 7.86688 16.8546 8.19388 16.4096C8.51988 15.9666 9.14388 15.8686 9.58788 16.1936C9.62488 16.2176 12.1719 18.0006 16.9999 18.0006C21.8469 18.0006 24.3869 16.2106 24.4119 16.1926C24.8559 15.8706 25.4819 15.9676 25.8069 16.4136C26.1309 16.8576 26.0369 17.4796 25.5949 17.8056C25.5119 17.8666 24.1389 18.8536 21.5349 19.4826L22.7099 21.0976C22.8249 21.2556 23.0079 21.3476 23.2019 21.3476C23.2089 21.3476 23.2149 21.3476 23.2209 21.3466C24.3219 21.3116 29.1499 20.4976 30.9199 17.3876C30.9729 17.2956 30.9999 17.1926 30.9999 17.0866C30.9999 11.0926 28.4359 4.15856 27.1199 2.94656ZM12.9999 15.0006C11.8949 15.0006 10.9999 13.8816 10.9999 12.5006C10.9999 11.1196 11.8949 10.0006 12.9999 10.0006C14.1049 10.0006 14.9999 11.1196 14.9999 12.5006C14.9999 13.8816 14.1049 15.0006 12.9999 15.0006ZM20.9999 15.0006C19.8949 15.0006 18.9999 13.8816 18.9999 12.5006C18.9999 11.1196 19.8949 10.0006 20.9999 10.0006C22.1049 10.0006 22.9999 11.1196 22.9999 12.5006C22.9999 13.8816 22.1049 15.0006 20.9999 15.0006Z",
    fill: "#ECB956"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171_978",
    x: -0.00012207,
    y: 0.651611,
    width: 34,
    height: 27.697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_978"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171_978",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.d613aaa32a467b17b2676bcf6814864b.svg";
export { ForwardRef as ReactComponent };